import { Component, Injector, OnInit, OnDestroy, AfterContentInit, ViewChild, WritableSignal, computed, signal } from '@angular/core';
import { DelfiComponentsLibraryModule } from '@mare-common/ngx-delfi-components';
import { EventInteractionService } from '@mare-common/ngx-mare-common';
import { SelfcaringDashboardComponent, SelfcaringWebComponentsModule } from '@mare-common/ngx-selfcaring-web-components';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { PlatformApiWpService } from '../services/platform-apiwp.service';
import { TokenService } from '../services/token.service';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormControl, FormGroupDirective, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ReportService } from '../services/report.service';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CompanyService } from '../services/company.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCardModule } from '@angular/material/card';
import { MatSliderModule } from '@angular/material/slider';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { CtaThankyou, ThankYouComponent } from '../thank-you/thank-you.component';
import { Subject, Subscription, catchError, finalize, of, takeUntil } from 'rxjs';
import { MatDividerModule } from '@angular/material/divider';
import { CommonConfig } from '../shared/common-config/common-config';
import { MediaMatcher } from '@angular/cdk/layout';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MareLoaderService } from '@mare-common/ngx-mare-loader';
import { DownloadAnimationDirective } from '../shared/directives/download-animation.directive';
import { MatTabsModule } from '@angular/material/tabs';
import { OrdersComponent } from './components/orders/orders.component';
import { ProductsRelatedComponent } from '../products-related/products-related.component';
import { VideoRecorderComponent } from '../shared/components/video-recorder/video-recorder.component';
import { ToolBenchmarkComponent } from '../tools/tool-benchmark/tool-benchmark.component';
import { PlaymetricsService } from '../services/playmetrics.service';
import { PlaymetricsComponent } from "../products-landings/playmetrics/playmetrics.component";
import { PlaymetricsToolComponent } from '../tools/playmetrics/playmetrics-tool.component';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { RoutingService } from '../services/routing.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AssessmentComponent } from '../assessment/assessment.component';
import { ToolSecurityAssesmentComponent } from '../tools/tool-security-assesment/tool-security-assesment.component';
import { BollettaComponent } from '../bolletta/bolletta.component';
import { PromoMarketplaceComponent } from '../promo/promo-marketplace/promo-marketplace.component';
import { InnovationProjectComponent } from '../innovation-project/innovation-project.component';
// import { ToolBenchmarkComponent } from '../report/components/tool-benchmark/tool-benchmark.component';
export enum SelfcaringTab {
  MY_SELFCARING = 0,
  ORDERS = 1,
  PROJECTS = 2,
  OFFER = 3,
  INNOVATION_PROJECT = 4,
  BENCHMARK = 5,
  PLAYMETRICS = 6,
  SECURITY_ASSESMENT = 7,
}

export interface ToolComponent {
  module: any;// tha standalone component ClassName
  name: string; // Displayed Name
  labelKey: string; // i18n label key
  idx: SelfcaringTab; // tab index
  inputs?: any; // inputs object {'key': value}
  visibilityCondition?: boolean | any; // condition for showing the tool
}

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-selfcaring',
  standalone: true,
  imports: [
    CommonModule,
    DelfiComponentsLibraryModule,
    // DownloadAnimationDirective,
    FormsModule,
    // MatBadgeModule,
    MatButtonModule,
    MatCardModule,
    // MatDividerModule,
    // MatExpansionModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    // MatSliderModule,
    // MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    NgOptimizedImage,
    OrdersComponent,
    // PlaymetricsComponent,
    PlaymetricsToolComponent,
    ProductsRelatedComponent,
    ReactiveFormsModule,
    SelfcaringWebComponentsModule,
    SharedModule,
    ThankYouComponent,
    ToolBenchmarkComponent,
    ToolSecurityAssesmentComponent,
    TranslateModule,
    VideoRecorderComponent,
    AssessmentComponent,
    BollettaComponent,
    InnovationProjectComponent,
    PromoMarketplaceComponent
  ],
  templateUrl: './selfcaring.component.html',
  styleUrls: ['./selfcaring.component.scss'],
  animations: [
    trigger('fadeInLeft', [
      state('void', style({
        opacity: 0,
        display: 'block',
        position:'relative',
        transform: 'translateX(100px)'
      })),
      transition('void => *', [
        animate('500ms {{delay}}ms ease-out', style({
          opacity: 1,
          transform: 'translateX(0%)'
        }))
      ], { params: { delay: 500 } }),
    ]),
  ]
})
export class SelfcaringComponent implements OnInit, OnDestroy {

  // @ViewChild('reportTable') table!: MatTable<any>;
  // @ViewChild('orderTable') orderTable!: MatTable<any>;
  @ViewChild('selfcaringApp') selfcaringApp!: SelfcaringDashboardComponent;

  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;

  mobileQuery: MediaQueryList
  pagetitle: string = 'Selfcaring';
  tokenServiceSub: Subscription = new Subscription();


  pageTitle!: string;
  pageSubtitle!: string ;
  tabs: any = SelfcaringTab;
  
  defaultTab = SelfcaringTab.ORDERS;
  currentTabIndex$ = signal(SelfcaringTab.ORDERS);
  selfcaringTabValues = Object.values(SelfcaringTab);
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  // = new MatTableDataSource<any>([])
  dataSource$ = computed(() => {
    return this.dataSource
  });

  orderDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([
  ])
  reportCount$ = signal<number>(0);

  hasRelated$ = signal<boolean>(false);
  hasBolletta$ = signal<boolean>(false);
  hasBenchmark$ = signal<boolean>(false);
  hasBenchmarkLite$ = signal<boolean>(false);
  hasPlaymetrics$ = signal<boolean>(false);
  hasSelfcaring$ = signal<boolean>(true);
  itemSelectedIsATool$ = computed(() => {
    if (
      this.currentTabIndex$() == SelfcaringTab.PLAYMETRICS ||
      this.currentTabIndex$() == SelfcaringTab.SECURITY_ASSESMENT ||
      this.currentTabIndex$() == SelfcaringTab.BENCHMARK) {
      return true
    }
    return false 
  })

  reportCountLimit = 0;
  // hasActivatedReport$ = signal<boolean>(false);
  displayedColumns: string[] = ['businessName', 'vatNumber', 'action'];
  orderDisplayedColumns: string[] = ['orderNumber', 'status', 'total', 'products'];
  newVatNumber: any;

  benchmarkVatNumber = new FormControl('', [Validators.required, Validators.pattern('[0-9]{11}'), Validators.minLength(11), Validators.maxLength(11)]);
  matcher = new MyErrorStateMatcher();

  companySub: any;
  orders: any;
  maxExpireRequestTime = 3600000; //1000 * 60 * 60 ;
  showSelfcaringDashboard: boolean = false;
  showThankYou$ = signal(false);
  unsubscribe$: Subject<any> = new Subject();

  ctaThankyou: CtaThankyou = {
    action: () => { this.closeThankYou() }
  }
  eventInteractionSubscription: Subscription;
  orderComplete!: boolean;
  // layoutABtest!: 'a' | 'b';

  mediaSize$ = signal<string>('xs'); // string = 'xs';
  currentScreenSize$ = computed(() => {
    return '_container-' + this.mediaSize$();
  });
  currentScreenSize!: string;
  maxElaborationTimeInHours: number = this.commonConfig.getFromConfig('maxElaborationTimeInHours', 1);

  loader: any;

  downloadingReportvatNumber$: WritableSignal<string[]> = signal([]);
  company: any;
 
  productPurchased?: string;

  tools: ToolComponent[] = [];
  // tools: ToolComponent[] = [
  //   { module: ToolSecurityAssesmentComponent, name: 'Security Assesment', labelKey: 'security_assesment', idx: SelfcaringTab.SECURITY_ASSESMENT, visibilityCondition: true }
  // ]
   
  
  constructor(
    private eventInteractionService: EventInteractionService,
    private platformApiWpService: PlatformApiWpService,
    private translateService: TranslateService,
    private tokenService: TokenService,
    private reportService: ReportService,
    private companyService: CompanyService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonConfig: CommonConfig,
    private media: MediaMatcher,
    private _snackBar: MatSnackBar,
    private injector: Injector,
    private loaderService: MareLoaderService,
    private playmetricsService: PlaymetricsService,
    private routingService: RoutingService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
  ) {
    this.loader = loaderService;
    iconRegistry.addSvgIcon(
      'playmetrics-icon', sanitizer.bypassSecurityTrustResourceUrl(environment.assetsPrefixUrl + '/images/icons/playmetrics-icon.svg')
    ); 
    iconRegistry.addSvgIcon(
      'benchmark-icon', sanitizer.bypassSecurityTrustResourceUrl(environment.assetsPrefixUrl + '/images/icons/benchmark-icon.svg')
    );
    iconRegistry.addSvgIcon(
      'projects-icon', sanitizer.bypassSecurityTrustResourceUrl(environment.assetsPrefixUrl + '/images/icons/projects-icon.svg')
    );
    iconRegistry.addSvgIcon(
      'order-icon', sanitizer.bypassSecurityTrustResourceUrl(environment.assetsPrefixUrl + '/images/icons/order-icon.svg')
    );
    iconRegistry.addSvgIcon(
      'offer-icon', sanitizer.bypassSecurityTrustResourceUrl(environment.assetsPrefixUrl + '/images/icons/offer-icon.svg')
    );
    iconRegistry.addSvgIcon(
      'myselfcaring-icon', sanitizer.bypassSecurityTrustResourceUrl(environment.assetsPrefixUrl + '/images/icons/grid-icon.svg')
    );

    this.mobileQuery = media.matchMedia('(max-width: ' + commonConfig.getMobileBreakpoint() + 'px)');

    if (activatedRoute.snapshot.queryParams['order_complete'] != undefined) {
      this.orderComplete = activatedRoute.snapshot.queryParams['order_complete'] == true || activatedRoute.snapshot.queryParams['order_complete'] == "true" ? true : false;
      this.productPurchased = this.orderComplete ? 'il servizio' : undefined;
      // TODO : recuperare il nome prodotto/servizio acquistato

      this.showThankYou$.set(true);
    }
    this.eventInteractionSubscription = this.eventInteractionService.getObservable().subscribe((data) => {
      switch (data.event) {
        case 'screensize':
          this.mediaSize$.set(data.data); // data.data;
          break;
        default:
          break;
      }

    })
    translateService.setDefaultLang('it');
    translateService.use('it');
  }
  
  ngOnInit() {
    this.setTitleByFragment();
    if (!this.tokenService.isInit) {
      this.tokenServiceSub = this.tokenService.isInit$.subscribe((isInit) => {
        if (isInit) {
          this._ngOnInit();
        }
      })
    } else {
      this._ngOnInit();
    }
  }
  ngOnDestroy() {
    if (this.tokenServiceSub)
      this.tokenServiceSub.unsubscribe();
    if (this.companySub)
      this.companySub.unsubscribe();

    this.unsubscribe$.unsubscribe();

    if (this.eventInteractionSubscription)
      this.eventInteractionSubscription.unsubscribe();
  }

  trackByFn(index: number, value: any) {
    return value;
  }

  getTranslate(key: string | string[], methodGet: boolean) {
    if (methodGet) {
      this.translateService.get(key).subscribe((res: any) => {
        return res
      })
    } else {
      return this.translateService.instant(key)
    }
  }
 

  setTitleByFragment() {
    let selected = this.routingService.checkForHash();
    let suffix = selected ?? SelfcaringTab[this.defaultTab];
    // if (selected != null) {
    //   suffix = selected;
    // } 
    suffix = suffix.toLowerCase();
      this.translateService.get(['page.selfcaring.tab.'+suffix+'.title', 'page.selfcaring.tab.'+suffix+'.subtitle']).subscribe((res: any) => {
        this.pageTitle = res[Object.keys(res)[0]] ?? '';
        this.pageSubtitle = res[Object.keys(res)[1]] ?? '';
      });
  }

  toolSelected() {
    this.setTabFromFragment();
    this.setTitleByFragment();
  }

  setTabFromFragment(){
    let selected = this.routingService.checkForHash();
    if (selected != null) {
      selected = selected.toUpperCase();
      const tabValue = SelfcaringTab[selected as keyof typeof SelfcaringTab];
      if(tabValue != undefined && tabValue!= this.currentTabIndex$()) {
        this.currentTabIndex$.set(tabValue);
      }
    } 
  }

  async _ngOnInit() {
    this.setTabFromFragment();
    if (this.companyService.company) {
      this.company = this.companyService.company;
      await this.setActiveTools(this.company);
      // hasPlaymetrics = await this.playmetricsService.havePlaymetrics();
      // this.hasPlaymetrics$.set(hasPlaymetrics);
      this.showSelfcaringDashboard = true;
    } else {
      this.companyService.retrieveCompany().then(async (company: any) => {
        this.company = company;
        this.setActiveTools(this.company);
        // hasPlaymetrics = await this.playmetricsService.havePlaymetrics();
        // this.hasPlaymetrics$.set(hasPlaymetrics);
      }).finally(() => {
        this.showSelfcaringDashboard = true;
      })
    }
  }

  setActiveTools(company: any) {
    this.hasRelated$.set(!!company?.delfi_offers);
    // this.hasBolletta$.set(!!company?.delfi_has_bolletta);
    this.hasBenchmark$.set(!!(company.delfi_report_max_requests && Number(company.delfi_report_max_requests) > 0));
    this.hasBenchmarkLite$.set(!!(company.delfi_report_max_light_requests && Number(company.delfi_report_max_light_requests) > 0));

    if (this.hasBenchmark$()) {
      this.tools.push({ module: ToolBenchmarkComponent, name: 'Benchmark', labelKey: 'benchmark', idx: SelfcaringTab.BENCHMARK, inputs:{'company': this.company}, visibilityCondition: this.hasBenchmark$() });
    }

    this.playmetricsService.havePlaymetrics().then(has => {
      this.hasPlaymetrics$.set(has);
      if (has) {
        this.tools.push({ module:PlaymetricsComponent, name: 'Playmetrics', labelKey: 'playmetrics', idx: SelfcaringTab.PLAYMETRICS, visibilityCondition: this.hasPlaymetrics$() });
      }
    });
  }

  openMenu() {
    if (this.mobileQuery.matches || this.trigger.menuOpen) return
    setTimeout(() => {
      this.trigger.openMenu();
    },50);
  }
  closeMenu() {
    if (this.mobileQuery.matches) return
    setTimeout(() => {
      this.trigger.closeMenu();
    },50);
  }

  closeThankYou() {
    const timeout = setTimeout(() => {
      if (window.opener) {
        // Chiude il tab corrente
        window.close();
      } else {
        console.log("Il tab corrente non ha un parent.");
      }
      this.showThankYou$.set(false);
      clearTimeout(timeout);
    }, 500)
  }

  SelectedTabIndexChange(index: number, key?: string) {
    if (key) {
    this.pageTitle = '';
    let arraystring = ['selfcaring_title_'+key, 'selfcaring_subtitle_' + key];
      let srt = this.getTranslate(arraystring, false);
      setTimeout(() => {
        this.pageTitle = srt['selfcaring_title_' + key] ?? '';
        this.pageSubtitle = srt['selfcaring_subtitle_' + key ] ?? '';
      },50)
    // this.pageTitle = srt['selfcaring_title_' + key] ?? '';
    // this.pageSubtitle = srt['selfcaring_subtitle_' + key ] ?? '';
      let indexKey: any = key.toUpperCase();
      let idx: any = SelfcaringTab[indexKey];
      this.currentTabIndex$.set(idx);
      window.location.hash = indexKey;
    } else {
      this.currentTabIndex$.set(index);
    }


    setTimeout(() => {
      this.trigger.closeMenu();
    }, 50);

  }
  handleSelfcaringEvent(event: any) {
    if (event == 'noSelfcaringData') {
      this.hasSelfcaring$.set(false);
    }
  }
  initOrders() {
    this.platformApiWpService.getRequest('msc/v1/getorders').then((sub: any) => {
      sub.pipe(
        catchError((err: any) => of([]))
      ).subscribe((response: any) => {
        console.log('__init orders ________________', response);
        if (response && response.status == 'ok') {
          this.orders = response.payload;
          // filter orders whois items array includes element with sku = report-digitale
          // const benckmarkSkus = this.commonConfig.getFromConfig('benckmarkSkus', ['report-digitale', 'report-digitale-mini', 'report-digitale-medium'])

          // let hasBoughtReports = this.orders.filter((el: any) => el.status == 'completed').filter((el: any) => {
          //   return el.items.find((_el: any) => benckmarkSkus.includes(_el.sku))
          // });

          // this.hasActivatedReport$.set(!!hasBoughtReports);
          this.orders.forEach((order: any) => {
            let newRow = {
              orderNumber: order.id,
              status: this.getTranslatedStatus(order.status),
              total: order.total,
              products: this.getProducts(order)
            }
            this.orderDataSource.data.push(newRow);
          });

          // this.orderTable.renderRows();
        } else {
          console.log(response);
          this.orders = [];
        }
      }, (err: any) => {
        console.log(err);
        this.orders = [];
      });
    }).catch((err: any) => {
      console.log(err);
    });
  }

  getTranslatedStatus(status: string): string {
    switch (status) {
      case 'pending':
        return 'in attesa';
      case 'processing':
        return 'in elaborazione';
      case 'completed':
        return 'completato';
      case 'cancelled':
        return 'cancellato';
    }
    return '';
  }

  getProducts(order: any) {
    let products: any[] = [];
    order.items.forEach((product: any) => {
      products.push(product.name + " " + product.total + "€");
    });
    return products.join(', ');
  }

  orderAction(event: any) {
    if (!event) return;
    switch (event.event) {
      case 'gotoTool':
        // let tool = event.element?.orderItems?.[0]?.name;
        // if (!tool) return;
        // let idx: number = SelfcaringTab[tool.toUpperCase() as keyof typeof SelfcaringTab];
        // this.SelectedTabIndexChange(idx, tool);
        
        this.reportService.downloadReport(this.company.piva)
        break;
    }
  }
}

